module.exports = __webpack_public_path__ + "img/10.6d1c1182.jpg";